var map = {
	"./01.jpg": "6c5b",
	"./02.jpg": "9028",
	"./03.jpg": "d255",
	"./04.jpg": "425a",
	"./05.jpg": "3fa9",
	"./06.jpg": "11d5",
	"./07.jpg": "747d",
	"./08.jpg": "2715",
	"./09.jpg": "76cf",
	"./10.jpg": "8b51",
	"./11.jpg": "4bd2",
	"./3d-design.jpg": "391d",
	"./application.jpg": "4181",
	"./css.jpg": "9e32",
	"./ebooks.png": "60bb",
	"./graphic-design.png": "dcb6",
	"./html.png": "bdf1",
	"./lecture-video-recorder.jpg": "ed1a",
	"./logo.jpg": "6ac4",
	"./main.jpg": "7587",
	"./php.png": "c406",
	"./web-dev.jpg": "c315",
	"./web-element.jpg": "5f60",
	"./wordpress.jpg": "2905"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5a41";